import React from "react";
import PropTypes from "prop-types";

export default function CardStats2({
  statSubtitle,
  statTitle,
  statTitle2,
  supply,
  demand,
  statIconName2,
  statIconName3,
  statIconColor2,
  statIconColor3,
}) {
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg">
        <div className="flex-auto p-4">
          <div className="flex flex-wrap">
            <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
              <h5 className="text-blueGray-400 uppercase font-bold text-xs">
                {statSubtitle}
              </h5>
              <br />
              <span className="font-semibold text-xl text-blueGray-700">
                <div
                className={
                  "text-white p-3 text-center inline-flex items-center justify-center w-10 h-10 shadow-lg rounded-full " +
                  statIconColor2
                }
              >
                <i className={statIconName2}></i>
              </div>
              {statTitle} 
              </span>
              <br />
              <br />
              <span className="font-semibold text-xl text-blueGray-700">
                <div
                className={
                  "text-white p-3 text-center inline-flex items-center justify-center w-10 h-10 shadow-lg rounded-full " +
                  statIconColor3
                }
              >
                <i className={statIconName3}></i>
              </div>
              {statTitle2} 
              </span>
              <br />
              <br />
              <span className="font-semibold text-xl text-blueGray-700">
                {supply} 
              </span>
              <br />
              <br />
              <span className="font-semibold text-xl text-blueGray-700">
                {demand} 
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

CardStats2.propDefaults = {
  statSubtitle: "",
  statTitle: "",
  statTitle2: "",
  supply: "",
  demand: "",
  statIconName2: "",
  statIconName3: "",
  statIconColor2: "",
  statIconColor3: "",
};


CardStats2.propTypes = {
  statSubtitle: PropTypes.string,
  statTitle: PropTypes.string,
  statTitle2: PropTypes.string,
  supply: PropTypes.string,
  demand: PropTypes.string,
  statArrow: PropTypes.oneOf(["up", "down"]),
  statPercent: PropTypes.string,
  // can be any of the text color utilities
  // from tailwindcss
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  statIconName2: PropTypes.string,
  statIconName3: PropTypes.string,
  // can be any of the background color utilities
  // from tailwindcss
  statIconColor: PropTypes.string,
  statIconColor2: PropTypes.string,
  statIconColor3: PropTypes.string,
};
